<template lang="pug">
v-container(fill-height)
  v-progress-circular.ma-auto(
    :width="10"
    color="primary"
    :size="125"
    indeterminate
  )
</template>

<script>
import authService from '@/services/API/auth';
import { mapActions } from 'vuex';
import JWTService from '@/services/JWTService';

export default {
  created() {
    this.init();
  },
  methods:{
    ...mapActions({
      'authInit': 'auth/init',
    }),
    async init() {
      const { code } = this.$route.query;
      const params = { auth_code: code };
      if (!code) this.$router.push('/login');

      try {
        const response = await authService.authCode(params);
        JWTService.setToken(response.data.data.access_token);
        JWTService.setRefreshToken(response.data.data.refresh_token);

        this.authInit().then(() => {
          this.$router.push('/');
          this.$toast.success('Вы успешно вошли');
        });
      } catch (error) {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style>

</style>
